import { createReducer, on } from '@ngrx/store';
import * as AdminActions from './admin.actions';

export interface AdminState {
	isAdmin: boolean;
}

export const initialState: AdminState = {
	isAdmin: false,
};

export const adminReducer = createReducer(
	initialState,
	on(AdminActions.setIsAdmin, (state, { isAdmin }) => {
		return { ...state, isAdmin };
	})
);
